import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppService } from './app.service';

@Injectable({
  providedIn: 'root'
})
export class PersonalApiKeyService {
  private baseURL = this.appService.config.apiBaseUrl;
  private options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

  constructor(
    private http: HttpClient,
    private appService: AppService
  ) { }

  // Creates a key and returns the one-time plaintext token payload.
  // Modified by Karanam on Oct 09 2026 to fix code review comment S-17/S-18: keys are self-service only; the admin (targetUserId) variant was removed. Original lines kept commented out.
  // generateToken(label: string, expiresDate: string, targetUserId?: number): Observable<any> {
  //   const endpoint = targetUserId && targetUserId > 0
  //     ? `${this.baseURL}/personal-api-key/admin/${targetUserId}/generate`
  //     : `${this.baseURL}/personal-api-key/generate`;
  generateToken(label: string, expiresDate: string): Observable<any> {
    const endpoint = `${this.baseURL}/personal-api-key/generate`;

    return this.http.post<any>(
      endpoint,
      { label, expiresDate },
      this.options)
      .pipe(
        map(res => res as any),
        catchError(this.handleError)
      );
  }

  // Gets all keys for the currently authenticated user.
  // Modified by Karanam on Oct 09 2026 to fix code review comment S-17/S-18: keys are self-service only; the admin (targetUserId) variant was removed. Original lines kept commented out.
  // getTokens(targetUserId?: number): Observable<any[]> {
  //   const endpoint = targetUserId && targetUserId > 0
  //     ? `${this.baseURL}/personal-api-key/admin/${targetUserId}/list`
  //     : `${this.baseURL}/personal-api-key/list`;
  getTokens(): Observable<any[]> {
    const endpoint = `${this.baseURL}/personal-api-key/list`;

    return this.http.get<any>(
      endpoint,
      { observe: 'response' })
      .pipe(
        map(res => (res.body || []) as any[]),
        catchError(this.handleError)
      );
  }

  // Revokes a single key owned by the logged-in user.
  // Modified by Karanam on Oct 09 2026 to fix code review comment S-17/S-18: keys are self-service only; the admin (targetUserId) variant was removed. Original lines kept commented out.
  // revokeToken(tokenId: number, targetUserId?: number): Observable<any> {
  //   const endpoint = targetUserId && targetUserId > 0
  //     ? `${this.baseURL}/personal-api-key/admin/${targetUserId}/revoke/${tokenId}`
  //     : `${this.baseURL}/personal-api-key/revoke/${tokenId}`;
  revokeToken(tokenId: number): Observable<any> {
    const endpoint = `${this.baseURL}/personal-api-key/revoke/${tokenId}`;

    return this.http.post<any>(
      endpoint,
      {},
      this.options)
      .pipe(
        map(res => res as any),
        catchError(this.handleError)
      );
  }

  // Normalizes API/network errors for caller toast handling.
  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof Error) {
      const errMessage = error.error.message;
      return throwError(errMessage);
    }

    return throwError(error || 'Node.js server error');
  }
}
